export const PRIMARY_COLUMN_KEYS = {
  ID: 'id',
  // Org-level only: the cross-collect view shows which collect each alert belongs to.
  COLLECT_NAME: 'collect_name',
  ALERT_NAME: 'alert_name',
  STATUT: 'statut',
  CATEGORIE: 'categorie',
  CREATED_AT: 'created_at',
  ATTRIBUTION: 'attribution',
  RESOURCE_NAME: 'resource_name',
  CONTENT: 'content'
}

// Per-collect column order/picker: COLLECT_NAME is org-only and intentionally absent.
export const PRIMARY_COLUMN_ORDER = [
  PRIMARY_COLUMN_KEYS.ID,
  PRIMARY_COLUMN_KEYS.ALERT_NAME,
  PRIMARY_COLUMN_KEYS.STATUT,
  PRIMARY_COLUMN_KEYS.CATEGORIE,
  PRIMARY_COLUMN_KEYS.CREATED_AT,
  PRIMARY_COLUMN_KEYS.ATTRIBUTION,
  PRIMARY_COLUMN_KEYS.RESOURCE_NAME,
  PRIMARY_COLUMN_KEYS.CONTENT
]

// Org-level order: the collect column sits right after ID.
export const ORGANIZATION_PRIMARY_COLUMN_ORDER = [
  PRIMARY_COLUMN_KEYS.ID,
  PRIMARY_COLUMN_KEYS.COLLECT_NAME,
  ...PRIMARY_COLUMN_ORDER.filter(key => key !== PRIMARY_COLUMN_KEYS.ID)
]

export const PRIMARY_COLUMN_LABELS = {
  [PRIMARY_COLUMN_KEYS.ID]: 'ID',
  [PRIMARY_COLUMN_KEYS.COLLECT_NAME]: 'Collecte',
  [PRIMARY_COLUMN_KEYS.ALERT_NAME]: 'Nom de l’alerte',
  [PRIMARY_COLUMN_KEYS.STATUT]: 'Statut',
  [PRIMARY_COLUMN_KEYS.CATEGORIE]: 'Catégorie',
  [PRIMARY_COLUMN_KEYS.CREATED_AT]: 'Déclenchée le',
  [PRIMARY_COLUMN_KEYS.ATTRIBUTION]: 'Attribution',
  [PRIMARY_COLUMN_KEYS.RESOURCE_NAME]: 'Nom de la ressource',
  [PRIMARY_COLUMN_KEYS.CONTENT]: 'Contenu'
}

export const PRIMARY_COLUMN_OPTIONS = PRIMARY_COLUMN_ORDER.map(key => (
  { value: key, label: PRIMARY_COLUMN_LABELS[key] }
))

// The ID column is mandatory; it is not offered in the customization picker.
export const CUSTOMIZABLE_PRIMARY_COLUMN_OPTIONS = PRIMARY_COLUMN_OPTIONS.filter(
  option => option.value !== PRIMARY_COLUMN_KEYS.ID
)

// Extra columns render just after ID; typed slots keep the header and rows in sync.
export const orderedColumnSlots = (primaryColumns, extraColumns) => {
  const primarySlots = primaryColumns.map(key => ({ kind: 'primary', key }))
  const extraSlots = extraColumns.map(column => ({ kind: 'extra', column }))
  const idIndex = primaryColumns.indexOf(PRIMARY_COLUMN_KEYS.ID)
  const afterId = idIndex === -1 ? primarySlots.length : idIndex + 1
  return [...primarySlots.slice(0, afterId), ...extraSlots, ...primarySlots.slice(afterId)]
}

export const DEFAULT_COLUMN_PREFERENCES = {
  primaryColumns: [...PRIMARY_COLUMN_ORDER],
  questionIds: [],
  variableIds: []
}

// Shared by questionIds and variableIds: a global cap is what keeps the table from overflowing.
export const MAX_EXTRA_COLUMNS = 10

export const EXTRA_COLUMN_TYPES = {
  QUESTION: 'question',
  VARIABLE: 'variable'
}

// Content filter axis (distinct from the CONTENT column key above).
export const CONTENT_FILTER_KEYS = {
  WITH_COMMENT: 'with_comment',
  WITH_PHOTOS: 'with_photos'
}

export const CONTENT_FILTER_OPTIONS = [
  { value: CONTENT_FILTER_KEYS.WITH_COMMENT, label: 'Avec commentaire' },
  { value: CONTENT_FILTER_KEYS.WITH_PHOTOS, label: 'Avec photos' }
]

// Shared by the three filter triggers of the alerts bar so they stay worded alike.
export const filterTriggerLabel = (name, selectedCount, total) =>
  selectedCount > 0 ? `${name} (${selectedCount}/${total})` : name

// Shared by every hook and mutation of the feature so toasts surface in the same place.
export const TOAST_CONTAINER_ID = 'alerts-toast'

// Statuses shown directly on a summary card; the rest go to the drawer.
export const VISIBLE_STATUSES_PER_CARD = 5

export const alertNoun = count => count > 1 ? 'alertes' : 'alerte'

// Wording mirrors the editor's radio group (cf. EditCollect/QuestionFields/DateTime).
export const DATETIME_FORMAT_LABELS = new Map([
  ['date_and_time', 'Date & heure'],
  ['only_date', 'Date'],
  ['only_time', 'Heure']
])

// Mirrors the wording the collect editor offers at creation (cf. EditCollect/SectionField).
export const QUESTION_CONTEXT_LABELS = new Map([
  ['grade', 'Notation'],
  ['photos', 'Photo'],
  ['selection', 'Choix unique'],
  ['selection_multi', 'Choix multiples'],
  ['comment', 'Commentaire'],
  ['numeric', 'Numérique'],
  ['signature', 'Signature'],
  ['variable', 'Variable'],
  ['datetime', 'Date / Heure'],
  ['plan', 'Plan']
])
